/**
 * https://github.com/sirg2003/vue-howler
 * VueHoler is a mixin
 */
import VueHowler from "vue-howler";

export default {
    mixins:[VueHowler],
    props: {
        rates: {
            type: Array,
            default() {
                return ["1.0", "1.5", "1.75", "2.0", "2.5", "3.0"];
            }
        },
        html5: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            // animations states
            isRewinding: false,
            isChanging: false,
            isForwarding: false
        }
    },
    filters: {
        formatSeconds(playingSeconds) {
            playingSeconds = parseInt(playingSeconds, 10);

            const hours = Math.floor(playingSeconds / 3600);
            let minutes = Math.floor((playingSeconds - (hours * 3600)) / 60);
            let seconds = playingSeconds - (hours * 3600) - (minutes * 60);

            if (minutes < 10) {
                minutes = `0${minutes}`;
            }

            if (seconds < 10) {
                seconds = `0${seconds}`;
            }

            // Sometimes when you're setting the progress `playingSeconds` returns NaN 🤷
            if (Number.isNaN(minutes) || Number.isNaN(seconds)) {
                minutes = "00";
                seconds = "00"
            }

            return `${minutes}:${seconds}`;
        }
    },
    computed: {
        playerProgress() {
            return Number.isNaN(this.progress) ? 0 : Math.round(this.progress * 100);
        },
        countdown() {
            let timeLeft = this.duration;
            if (this.seek > 0) {
                timeLeft = this.duration - this.seek;
            }
            return timeLeft;
        }
    },
    methods: {
        togglePlay() {
            // The following block of code is intended for the change animation
            this.isChanging = true;

            setTimeout(() => {
                this.isChanging = false;
            }, 100);
            // VueHowler mixin method
            if (this.playing) {
                this.pause();
            } else {
                this.play();
            }
        },
        forward() {
            // The following block of code is intended for the forward animation
            this.isForwarding = true;
            setTimeout(() => {
                this.isForwarding = false;
            }, 100);
            let newSeek = Number(this.seek + 30);
            if (this.duration < newSeek) {
                newSeek = this.duration;
            }
            this.setPlayerSeek(newSeek);
        },
        rewind() {
            // The following block of code is intended for the rewind animation
            this.isRewinding = true;
            setTimeout(() => {
                this.isRewinding = false;
            }, 100);
            let newSeek = Number(this.seek - 30);
            if (0 > newSeek) {
                newSeek = 0;
            }
            this.setPlayerSeek(newSeek);
        },

        setPlayerProgress(value) {
            // VueHowler mixin method
            this.setProgress(value);
        },
        setPlayerSeek(value) {
            // VueHowler mixin method
            this.setSeek(value);
        },
        nextRate() {
            const currentRateIndex = this.rates.findIndex(this.rate);

            let rate = "1.0";
            if (this.rates.length > (currentRateIndex + 1)) {
                rate = this.rates[currentRateIndex + 1];
            }

            this.changeRate(rate);
        },
        changeRate(rate) {

            // VueHowler mixin method
            this.setRate(Number(rate));
        }
    }
}
